<template lang="pug">
#wt-full-page-loader
  .columns.is-centered.is-vcentered.is-mobile
    .shoebox
      .leg.left
        .shoe
      .leg.right
        .shoe
</template>

<script>
export default {
  name: "WtFullPageLoader"
};
</script>

<style lang="sass" scoped>
#wt-full-page-loader
  @keyframes leg-swing
    0%,100%
      transform: rotate(-23deg) translateX(70px) translateY(20px)
    50%
      transform: rotate(42deg) translateX(-5px)


  @keyframes shoe-turn
    0%,100%
      transform: rotate(-20deg) translateY(0px) translateX(10px)
    25%
      transform: rotate(0deg) translateY(0px) translateX(0)
      bottom: 66px
    30%
      transform-origin: 100% 5%
    50%
      transform: rotate(-5deg) translateY(-30px) translateX(10px)
    75%
      transform: rotate(0deg) translateY(-50px) translateX(0)
      bottom: 69px

  .shoebox
    position: relative
    animation-fill-mode: both

  .leg
    position: absolute
    left: -120px
    width: 150px
    height: 245px
    transform-origin: 50% 0%

  .shoe
    position: absolute
    width: 150px
    height: 110px
    bottom: 20px
    background: url("~@/assets/WT_Shoe-Gray.png") center center no-repeat
    background-size: contain
    transform-origin: 0 95%
    transform: rotate(-18deg)

  .left
    animation: leg-swing 1.5s ease-in-out infinite
    .shoe
      animation: shoe-turn 1.5s ease-in-out infinite

  .right
    animation: leg-swing 1.5s ease-in-out -.75s infinite
    .shoe
      animation: shoe-turn 1.5s ease-in-out -.75s infinite

  .columns
    height: 25vh
</style>
